// skipcq: JS-W1028
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import { useBrewhousePageHeaderRegistration } from './BrewhousePageHeaderContext';

/** Shared padding for brewhouse portal page content. */
export const BREWHOUSE_PAGE_SHELL_SX = {
  py: { xs: 2, md: 3 },
  px: { xs: 2, sm: 3 },
};

/**
 * Brewhouse portal page wrapper with standard padding.
 * Registers breadcrumbs, back link, and title with the layout header via context.
 *
 * @param {object} props
 * @param {import('./BrewhouseBreadcrumbs').BrewhouseBreadcrumbSegment[]} [props.breadcrumbs]
 * @param {{ to: string, label: string }} [props.backLink]
 * @param {string} [props.title]
 * @param {string} [props.titleTestId]
 * @param {import('react').ReactNode} [props.headerChildren]
 * @param {import('react').ReactNode} props.children
 * @param {object} [props.sx]
 * @param {number | string} [props.maxWidth]
 */
function BrewhousePageShell({
  breadcrumbs = [],
  backLink = null,
  title = null,
  titleTestId = null,
  headerChildren = null,
  children,
  sx = {},
  maxWidth = null,
}) {
  useBrewhousePageHeaderRegistration({
    breadcrumbs,
    backLink,
    title,
    titleTestId,
  });

  const shellSx = {
    ...BREWHOUSE_PAGE_SHELL_SX,
    ...(maxWidth !== null ? { maxWidth, mx: 'auto' } : {}),
    ...sx,
  };

  return (
    <Box sx={shellSx}>
      {headerChildren}
      {children}
    </Box>
  );
}

BrewhousePageShell.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string,
    }),
  ),
  backLink: PropTypes.shape({
    to: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  title: PropTypes.string,
  titleTestId: PropTypes.string,
  headerChildren: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BrewhousePageShell;
